export const formatSsn = (ssn: string) => {
    const result = ssn.replace(/[^(\d|x)]/gi, '');
    if (result.length <= 3) {
        return result.replace(/(.{1,3})/, '$1');
    }
    if (result.length <= 5) {
        return result.replace(/(.{1,3})(.{1,2})/, '$1-$2');
    }
    return result.replace(/(.{1,3})(.{1,2})(.{1,4})/, '$1-$2-$3');
};

export const hideSsn = (ssn: string) => {
    // already hidden
    if (ssn.includes('X')) {
        return ssn;
    }

    const val = ssn.replace(/\D/g, '');
    let hidden = '';
    const digits = val.split('');
    digits.forEach((digit, index) => {
        let tempDigit = digit;
        if (index < 5) {
            tempDigit = 'X';
        }
        hidden += tempDigit;
    });
    return formatSsn(hidden);
};

export const formatPhoneNumber = (phoneNumber: string) => {
    const result = phoneNumber.replace(/[^\d]/gi, '');
    if (result.length <= 3) {
        return result.replace(/(.{1,3})/, '$1');
    }
    if (result.length <= 6) {
        return result.replace(/(.{1,3})(.{1,3})/, '($1) $2');
    }
    return result.replace(/(.{1,3})(.{1,3})(.{1,4})/, '($1) $2-$3');
};

export const spouseContactFormatter = (contactInfo: string) => {
    const result = contactInfo.replace(/[\(-\) ]/gi, '');
    if (result.length <= 9 && /^\d{1,9}$/i.test(result)) {
        return formatPhoneNumber(contactInfo);
    }
    return contactInfo;
};

export const formatAmount = (amount: string) => {
    let result = amount.replace(/[^\d.]/gi, '');
    result = result.replace(/^0+(\d)/g, '$1');
    return result;
};

export const amountValidator = (amount: string) => {
    const regexp = new RegExp('^\\d*.?\\d{0,2}$');
    return regexp.test(amount);
};

export const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});
